import styled from 'styled-components';

export const ReportsContainer = styled.div`
  height: calc(100vh - 120px);
  overflow: auto;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ReportCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: ${({ theme }) => theme.background};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

export const ReportInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  span:first-child {
    font-weight: bold;
  }

  span:last-child {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.textSecondary};
  }
`;
